module.exports = __webpack_public_path__ + "static/media/wavm8s-014-valiska.bb1b684.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-014-valiska.mp3
// module id = Vlv/
// module chunks = 0